var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from '@angular/common/http';
import { environment } from '@src/environments/environment';
export class AppConfigService {
    /**
     *Creates an instance of AppConfigService.
     * @param {HttpClient} http
     * @memberof AppConfigService
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * Load the settings from assets/app-settings.json file
     *
     * @memberof AppConfigService
     */
    loadSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            const jsonFile = environment.production ? `assets/app-settings.json` : `assets/app-settings.local.json`;
            yield new Promise((resolve, reject) => {
                this.http
                    .get(jsonFile)
                    .toPromise()
                    .then((response) => {
                    AppConfigService.config = response;
                    resolve(); //Return Sucess
                })
                    .catch((response) => {
                    console.log('Failed to load appSettings:', response);
                    resolve();
                });
            });
        });
    }
}
